import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ax from '../config';
import { openNotification } from 'src/components/helpers/notification';


const initialState = {

};

export const passwrordDecoder = createAsyncThunk('passwrordDecoder', async (payload, { dispatch }) => {
    try {
        const { data } = await ax.post('/api/cryptography/Decode', payload)
        return data
    } catch (error) {
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const HelperSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setErrorNotAllFields: (state, action) => {
            openNotification({
                type: 'error',
                message: 'Заполните обязательные поля'
            })
        }
    },
    extraReducers: (builder) => {
    }
});

export const { setErrorNotAllFields } = HelperSlice.actions;

export default HelperSlice.reducer